import { useMutation, useQueryClient } from "react-query";

import axios from "axios";
import { AUTOMATION_SERVICE_ADDRESS } from "constants/app.constants";

import {
  AUTOMATION_SCHEDULES_QUERY_KEY,
  AutomationSchedule
} from "./useFetchAutomationSchedules";

interface UpdateScheduleRequest {
  id: string;
  name?: string;
  automationId?: string;
  schedule?: {
    type?: "once" | "daily" | "weekly" | "monthly";
    startDate?: string;
    endDate?: string;
    time?: string;
    dayOfWeek?: number;
    dayOfMonth?: number;
  };
  emailTemplate?: {
    subject: string;
    body: string;
    recipients: string[];
  };
  isActive?: boolean;
}

const updateAutomationSchedule = async ({
  id,
  ...updateData
}: UpdateScheduleRequest): Promise<AutomationSchedule> => {
  const response = await axios.put<AutomationSchedule>(
    `${AUTOMATION_SERVICE_ADDRESS}/api/schedules/${id}`,
    updateData
  );
  return response.data;
};

export default function useUpdateAutomationSchedule() {
  const queryClient = useQueryClient();

  return useMutation(updateAutomationSchedule, {
    onSuccess: () => {
      queryClient.invalidateQueries(AUTOMATION_SCHEDULES_QUERY_KEY);
    }
  });
}
